import request from '../../Request';
import AppConfig from 'qs-config/AppConfig';

export const getFeaturePlan = () =>
  request.authGet(`${AppConfig.qsApiEndPoint}/v1/plan-feature/features`);
